import { Component, OnInit, Input } from '@angular/core';
import { ClientesService } from '../../../services/Clientes.service';
import { FormGroup, FormControl } from '@angular/forms';
import { RutasService } from '../../../services/rutas.service';
// Ngb
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertasModales } from '../../../helpers/alertasModales';
@Component({
  selector: 'app-importar-clientes-ruta',
  templateUrl: './importar-clientes-ruta.component.html',
  styleUrls: ['./importar-clientes-ruta.component.css']
})
export class ImportarClientesRutaComponent implements OnInit {
  @Input() ID_RUTA;
  @Input() modals: AlertasModales;
  form: FormGroup;
  formCliente: FormGroup;
  clientes = [];
  rutas = [];
  loading = false;
  clientesSeleccionado = [];
  dias = 0;
  razon = '';
  siguiente: boolean;
  constructor(
    private clienteService: ClientesService,
    public activeModal: NgbActiveModal,
    private rutasService: RutasService
  ) {
    this.initForm();
  }

  ngOnInit() {
    this.initRutas();
  }

  private initForm(): void {
    this.form = new FormGroup({
      nombre: new FormControl(''),
      cedula: new FormControl(''),
      ruta: new FormControl(''),
    });
  }

  private initClientes(): void {
    this.clienteService.importarClienteRuta(this.form.value)
    .subscribe(res => {
      if (res) {
        for (const row of res) {
          for (const seleccionado of this.clientesSeleccionado) {
            if (row.ID_CLIENTE === seleccionado.ID_CLIENTE && seleccionado.checked) {
              row.checked = true;
              break;
            }
          }
        }
        this.clientes = res;
      }
    }, err => {
      if (err.status == 403) {
        this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
        'red',
        'modern',
        false,
        'fa fa-file-text');
      }
    });

  }

  private initRutas(): void {
    this.rutasService.cargarTodasLasRutas()
    .subscribe(res => {
      this.rutas = res.rutas.filter(ruta => ruta.ID_RUTA !== this.ID_RUTA);
    });
  }

  filtrar(): void {
    this.initClientes();
  }

  pushClientesSelect(cliente) {
    const indexOf = this.clientesSeleccionado.indexOf(cliente);
    cliente.checked = !cliente.checked;
    if (indexOf > -1) {
      this.clientesSeleccionado.splice(indexOf, 1);
    } else {
      this.clientesSeleccionado.push(cliente);
    }
  }

  pushTodosClientesSelect() {
    this.clientesSeleccionado = [];
    for (const row of this.clientes) {
      row.checked = true;
    }
    this.clientesSeleccionado.push(...this.clientes);
  }

  desmarcarTodos() {
    for (const cliente of this.clientes) {
      cliente.checked = false;
    }
    this.clientesSeleccionado = [];
  }

  guardar() {
    if (this.clientesSeleccionado.length && this.razon) {
      const data = {
        ID_RUTA: this.ID_RUTA,
        dias: this.dias,
        clientes: this.clientesSeleccionado,
        razon: this.razon
      };
      this.clienteService.moverClientesRuta(data)
      .subscribe(
        () => this.activeModal.close('OK'),
        err => {
          if (err.status == 403) {
            this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
            'red',
            'modern',
            false,
            'fa fa-file-text');
          }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/importar-clientes-ruta/importar-clientes-ruta.component.ts